"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/web.timers.js");
require("core-js/modules/es.parse-int.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.string.link.js");
var _react = _interopRequireWildcard(require("react"));
var _classnames3 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _Tag = _interopRequireDefault(require("../Tag"));
var _ViewFill22Icon = _interopRequireDefault(require("../Icon/icons/ViewFill22Icon"));
var _ViewFillIcon = _interopRequireDefault(require("../Icon/icons/ViewFillIcon"));
var _ShareIcon = _interopRequireDefault(require("../Icon/icons/ShareIcon"));
var _ViewIcon = _interopRequireDefault(require("../Icon/icons/ViewIcon"));
var _teaComponent = require("@tencent/tea-component");
var _Link = _interopRequireDefault(require("../Link"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// 在这里引入 tea-portal 组件，样式在 style/index.ts 中引入
// import Avatar from '@tencent/tea-portal/lib/Avatar';

// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';
var HomeHero = function HomeHero(props) {
  var _classnames, _version$link;
  var className = props.className,
    style = props.style,
    avatar = props.avatar,
    vip = props.vip,
    name = props.name,
    activites = props.activites,
    fans = props.fans,
    tags = props.tags,
    industryTags = props.industryTags,
    onAdd = props.onAdd,
    onClose = props.onClose,
    onIndustryClose = props.onIndustryClose,
    onIndustryAdd = props.onIndustryAdd,
    type = props.type,
    bg = props.bg,
    theme = props.theme,
    _props$full = props.full,
    full = _props$full === void 0 ? true : _props$full,
    btns = props.btns,
    onClickEdit = props.onClickEdit,
    onClickActivites = props.onClickActivites,
    onClickFans = props.onClickFans,
    bgcolor = props.bgcolor,
    bgMb = props.bgMb,
    responsive = props.responsive,
    preview = props.preview,
    radius = props.radius,
    affiliation = props.affiliation,
    onSwitchAccount = props.onSwitchAccount,
    version = props.version;
  var _useClassNames = (0, _teaComponent.useClassNames)(),
    Margin = _useClassNames.Margin;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('home-hero');
  var classes = (0, _classnames3.default)(prefixCls, className, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "type-".concat(type), !!type && type !== 'default'), (0, _defineProperty2.default)(_classnames, "theme-".concat(theme), !!theme && theme !== 'default'), (0, _defineProperty2.default)(_classnames, 'is-radius', radius), (0, _defineProperty2.default)(_classnames, "responsive", responsive), _classnames));
  var maskRef = (0, _react.useRef)(null);
  var bgmaskRef = (0, _react.useRef)(null);
  var bgRmaskRef = (0, _react.useRef)(null);
  var nameRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    switchAccountSimple = _useState2[0],
    setSwitchAccountSimple = _useState2[1];
  (0, _react.useEffect)(function () {
    var mask = maskRef.current;
    var bgmask = bgmaskRef.current;
    var bgRmask = bgRmaskRef.current;
    if (bgcolor) {
      mask.style.background = "linear-gradient( to right, ".concat(bgcolor, ", 0%, ").concat(hexToRgba(bgcolor, 1), " 30%, ").concat(hexToRgba(bgcolor, 0.5), " 80%,").concat(hexToRgba(bgcolor, 0), "  100% )");
      bgmask.style.background = "linear-gradient(to right,  ".concat(hexToRgba(bgcolor, 1), " 0%,").concat(hexToRgba(bgcolor, 0), " 100%)");
      bgRmask.style.background = "linear-gradient(to left,  ".concat(hexToRgba(bgcolor, 1), " 0%,").concat(hexToRgba(bgcolor, 0), " 100%)");
    }
  });
  (0, _react.useEffect)(function () {
    handleSwitchSimple();
    var timer;
    var handleResize = function handleResize() {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        handleSwitchSimple();
      }, 500);
    };
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  var handleSwitchSimple = function handleSwitchSimple() {
    var ref = nameRef.current;
    if (!ref) {
      return;
    }
    setSwitchAccountSimple(ref.scrollWidth > ref.offsetWidth);
  };
  var hexToRgba = function hexToRgba(hex, opacity) {
    return "rgba(".concat(parseInt("0x".concat(hex.slice(1, 3))), ",\n      ").concat(parseInt("0x".concat(hex.slice(3, 5))), ",\n      ").concat(parseInt("0x".concat(hex.slice(5, 7))), ",\n      ").concat(opacity, ")");
  };
  var finalStyle = _objectSpread({
    // backgroundImage: `url(${bg})`,
    backgroundColor: "".concat(bgcolor)
  }, style);
  var clickEditHandle = function clickEditHandle() {
    if (typeof onClickEdit === 'function') {
      onClickEdit();
    }
  };
  var clickActivesHandle = function clickActivesHandle() {
    if (typeof onClickActivites === 'function') {
      onClickActivites();
    }
  };
  var clickFansHandle = function clickFansHandle() {
    if (typeof onClickFans === 'function') {
      onClickFans();
    }
  };
  var switchAccountHandle = function switchAccountHandle() {
    if (typeof onSwitchAccount === 'function') {
      onSwitchAccount();
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: finalStyle
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)("".concat(prefixCls, "__obj--section"), {
      'is-not-full': !full
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)("".concat(prefixCls, "__obj"))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)("".concat(prefixCls, "__obj--img-radius")),
    style: {
      backgroundImage: "url(".concat(bg, ")")
    }
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: bg,
    className: (0, _classnames3.default)("".concat(prefixCls, "__obj--img"))
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: bgmaskRef,
    className: (0, _classnames3.default)("".concat(prefixCls, "__obj--mask"))
  }), /*#__PURE__*/_react.default.createElement("div", {
    ref: bgRmaskRef,
    className: (0, _classnames3.default)("".concat(prefixCls, "__obj--mask right"))
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)("".concat(prefixCls, "__obj--section-mb"))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)("".concat(prefixCls, "__obj")),
    style: {
      backgroundImage: "url(".concat(bgMb, ")")
    }
  })), preview && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)("".concat(prefixCls, "__preview"))
  }, /*#__PURE__*/_react.default.createElement(_ViewFill22Icon.default, {
    className: "ma-show-pc"
  }), /*#__PURE__*/_react.default.createElement(_ViewFillIcon.default, {
    className: "ma-show-mobile"
  }), preview), /*#__PURE__*/_react.default.createElement("div", {
    ref: maskRef,
    className: (0, _classnames3.default)("".concat(prefixCls, "__mask"), {
      'is-not-full': !full
    })
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)("".concat(prefixCls, "__inner"), {
      'is-full': full
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__media")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__avatar"),
    style: {
      backgroundImage: "url(".concat(avatar, ")")
    }
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "".concat(prefixCls, "__sign ").concat(vip)
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__media-main")
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "".concat(prefixCls, "__name")
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "__name-text"),
    ref: nameRef
  }, name), version && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames3.default)("".concat(prefixCls, "__version"), (0, _defineProperty2.default)({}, "is-".concat(version === null || version === void 0 ? void 0 : version.type), version.type))
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "__version-text"),
    onClick: function onClick() {
      if (typeof version.onClickText === 'function') {
        version.onClickText(version);
      }
    }
  }, (version === null || version === void 0 ? void 0 : version.type) && /*#__PURE__*/_react.default.createElement("i", {
    className: "".concat(prefixCls, "__version-icon ").concat(version.type)
  }), /*#__PURE__*/_react.default.createElement("span", null, version === null || version === void 0 ? void 0 : version.text)), (version === null || version === void 0 ? void 0 : version.link) && /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "__version-extra link")
  }, /*#__PURE__*/_react.default.createElement(_Link.default, {
    type: ((_version$link = version.link) === null || _version$link === void 0 ? void 0 : _version$link.type) || 'primary-arrow',
    onClick: function onClick(event) {
      var _version$link2;
      if (typeof (version === null || version === void 0 ? void 0 : (_version$link2 = version.link) === null || _version$link2 === void 0 ? void 0 : _version$link2.onClick) === 'function') {
        version.link.onClick(event);
      }
    }
  }, version.link.text)), (version === null || version === void 0 ? void 0 : version.expireDate) && /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "__version-extra")
  }, version === null || version === void 0 ? void 0 : version.expireDate)), onClickEdit && /*#__PURE__*/_react.default.createElement("button", {
    className: "".concat(prefixCls, "__edit"),
    onClick: function onClick() {
      clickEditHandle();
    }
  }, "\u7F16\u8F91"), onSwitchAccount && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames3.default)("".concat(prefixCls, "__account"), {
      'is-simple': switchAccountSimple
    }),
    onClick: function onClick() {
      switchAccountHandle();
    }
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "".concat(prefixCls, "__account-icon")
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "__account-text")
  }, "\u5207\u6362"))), /*#__PURE__*/_react.default.createElement("ul", {
    className: (0, _classnames3.default)("".concat(prefixCls, "__infos"), {
      'has-affiliation': !!affiliation
    })
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames3.default)("".concat(prefixCls, "__info"), {
      'none-events': typeof onClickActivites !== 'function'
    }),
    onClick: function onClick() {
      return clickActivesHandle();
    }
  }, "\u6D3B\u52A8 ", /*#__PURE__*/_react.default.createElement("em", null, activites)), /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames3.default)("".concat(prefixCls, "__info"), {
      'none-events': typeof onClickFans !== 'function'
    }),
    onClick: function onClick() {
      return clickFansHandle();
    }
  }, "\u7C89\u4E1D ", /*#__PURE__*/_react.default.createElement("em", null, fans))), affiliation && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__affiliation")
  }, "IP\u5C5E\u5730\uFF1A", affiliation))), /*#__PURE__*/_react.default.createElement(_Tag.default, {
    items: tags,
    otherTags: industryTags,
    onOtherAdd: onIndustryAdd,
    onOtherClose: onIndustryClose,
    otherAddText: '行业',
    onClose: onClose,
    onAdd: onAdd,
    className: "".concat(prefixCls, "__tags"),
    responsive: responsive
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__btns")
  }, !btns && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_teaComponent.Button, {
    className: "".concat(prefixCls, "__btn")
  }, /*#__PURE__*/_react.default.createElement(_ShareIcon.default, null), "\u5206\u4EAB"), /*#__PURE__*/_react.default.createElement(_teaComponent.Button, {
    className: "".concat(prefixCls, "__btn")
  }, /*#__PURE__*/_react.default.createElement(_ViewIcon.default, null), "\u9884\u89C8\u6548\u679C")), btns)), radius && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__btns ").concat(prefixCls, "__btns--radius")
  }, !btns && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_teaComponent.Button, {
    className: "".concat(prefixCls, "__btn")
  }, /*#__PURE__*/_react.default.createElement(_ShareIcon.default, null), "\u5206\u4EAB"), /*#__PURE__*/_react.default.createElement(_teaComponent.Button, {
    className: "".concat(prefixCls, "__btn")
  }, /*#__PURE__*/_react.default.createElement(_ViewIcon.default, null), "\u9884\u89C8\u6548\u679C")), btns));
};
var _default = HomeHero;
exports.default = _default;